import { ActivityTypesEnum } from './ActivityTypesEnum';
import { ILocationToExclude } from './ILocationToExclude.interface';
import { OrderByEnum } from './OrderByEnums';
import { SearchDateRange } from './SearchDateRange';
import {IDrugSearchParams} from './drug-search-params.interface';

export interface ISearchCriteria {
  searchTerms: string;
  pharmacyId: string;
  searchDateRange: number;
  pageSize: number;
  page: number;
  orderBy: OrderByEnum;
  orderByAscending: boolean;
}

export interface ITransactionSearchCriteria extends ISearchCriteria {
  drugId: string | null;
  activityType: number | null;
}

export class TransactionSearchCriteria implements ITransactionSearchCriteria {
  searchTerms = null;
  pharmacyId = null;
  searchDateRange = SearchDateRange.All;
  pageSize = 1000;
  page = 0;
  drugId = null;
  activityType = null;
  createById = null;
  offset: number;
  withRecentTransactionDateChangeHistory: boolean;
  orderBy = OrderByEnum.TransactionDate;
  orderByAscending: boolean; 
  schedules?: number[] = [];
  locationID?: string;
  inventoryLocations?: string[];
}

export interface IInventoryInfoRequest extends IDrugSearchParams {
  pharmacyID: string | null;
  drugID: string | null;
  token: string | null;
  skip: number;
  limit: number;
  limitToPharmacy: boolean;
  active?: boolean;
}

export class InventoryInfoRequest implements IInventoryInfoRequest {
  pharmacyID = null;
  drugID = null;
  token = '';
  skip = 0;
  limit = 1000;
  limitToPharmacy = true;
  active = true;
  searchEmptyInventory = true;
  withLastAudit = false;
  schedules?: number[] = [];
  locationId?: string;
  singleLocationResult?: boolean;
  locationsToExclude?: ILocationToExclude[];
  gpi?: string;
}

